// ═══════════════════════════════════════════════════════════════════
//  modules/projets/highlight.js
//  _highlightSet · _highlightPromise · getHighlightSet
// ═══════════════════════════════════════════════════════════════════

import { API_BASE } from "../../socle/api";

// ═══════════════════════════════════════════════════════════════════════
//  BOUTON « METTRE EN AVANT »  (pour la Gestion de Projet)
//  But : mettre une tâche dans l'encart « On y travaille » du Dashboard,
//        avec un court résumé généré par l'IA.
//
//  1) Colle ce composant dans App.js (n'importe où au niveau racine, ex.
//     juste AVANT  function TaskCard(...)  ).
//  2) Dans TaskCard, ajoute le bouton dans la zone d'actions de la carte.
//     Exemple d'emplacement (vers la ligne 666, à côté du bouton « réclamer ») :
//
//        <TaskHighlightButton taskId={task.id} token={token} />
//
//     (TaskCard reçoit déjà `task` et `token` en props.)
// ═══════════════════════════════════════════════════════════════════════

// Cache module : un seul appel pour connaître les tâches déjà mises en avant.
export let _highlightSet = null;

export let _highlightPromise = null;

export function getHighlightSet(token) {
  if (_highlightSet) return Promise.resolve(_highlightSet);
  if (!_highlightPromise) {
    _highlightPromise = fetch(`${API_BASE}/api/dashboard/highlights`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((ids) => { _highlightSet = new Set(ids); return _highlightSet; })
      .catch(() => { _highlightSet = new Set(); return _highlightSet; });
  }
  return _highlightPromise;
}
